// extracted by mini-css-extract-plugin
export default {"col":"PositiveResult_col__k07al","back":"PositiveResult_back__EjHHB","indent":"PositiveResult_indent__6gzK5"};